import {Component} from '@angular/core';
import {Input} from '@angular/core';
import {NgModel} from '@angular/forms';

@Component({
    selector: 'ui-input-error',
    template: '<span *ngIf="error"><ng-content></ng-content></span>'
})
export class UIInputErrorComponent {

    @Input()
    input: NgModel;

    @Input()
    name: string;

    @Input()
    showErrorValidation: boolean = false;

    get error(): boolean {
      const { input, name, showErrorValidation } = this;
        if (showErrorValidation) {
          return showErrorValidation;
        }
        if (input.dirty || input.touched) {
            return input.errors && input.errors[name];
        }
        return showErrorValidation;
    }
}
